@use 'sass:math';
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/global.variables' as globalVariables;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/spacing.variables' as spacing;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/colours.variables' as colours;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/breakpoints.variables' as breakpoints;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/fonts.variables' as fonts;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/line-heights.variables' as lineheight;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/font-weights.variables' as fontWeights;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/z-index.variables' as zIndex;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/2-tools/functions/global.functions' as globalFunctions;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/2-tools/placeholder/focus.placeholders' as
	focusPlaceholders;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/4-elements/_global.elements.scss';
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/7-overrides/_visibility.overrides.scss';

@use '../../styles/fieldsets.scss';
@use '../../styles/labels.scss';
@use '../../styles/text-inputs.scss';

$ontario-input-height: globalFunctions.px-to-rem(48);
$ontario-search-icon-size: 2rem;
$ontario-reset-icon-size: 1.5rem;
$ontario-search-button-width: 5rem;
$ontario-search-button-width--mobile: 3rem;
$ontario-search-input-padding: 8.5rem;
$ontario-search-input-padding--mobile: 7.75rem;
$ontario-search-desktop-width: 34rem;
$ontario-search-mobile-width: 20.5rem;
$ontario-search-autosuggest-box-shadow: #0000001a;
$ontario-search-autocomplete-disabled-opacity: 0.65;

.ontario-search__container {
	max-width: $ontario-search-desktop-width;
	margin-bottom: spacing.$spacing-7;
}

.ontario-search__input-container {
	position: relative;
}

.ontario-search__input-suggestion-container {
	position: relative;
}

.ontario-search__input.ontario-input {
	border: 2px solid colours.$ontario-colour-black;
	margin-bottom: spacing.$spacing-0;
	height: $ontario-input-height;
	padding-left: spacing.$spacing-3;
	padding-right: $ontario-search-input-padding;
	width: 100%;

	&:invalid + input[type='reset'] {
		display: none;
	}

	&:focus {
		@extend %ontario-focus;
	}
}

input[type='reset'].ontario-search__reset {
	position: absolute;
	display: flex;
	align-items: center;
	top: spacing.$spacing-3;
	right: $ontario-search-button-width + spacing.$spacing-4;
	height: $ontario-reset-icon-size;
	width: $ontario-reset-icon-size;
	color: colours.$ontario-colour-black;
	margin: spacing.$spacing-0;
	padding: spacing.$spacing-1;
	background-size: $ontario-reset-icon-size;
	background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSI+PHBhdGggZD0iTTE5IDYuNEwxNy42IDUgMTIgMTAuNiA2LjQgNSA1IDYuNGw1LjYgNS42TDUgMTcuNiA2LjQgMTlsNS42LTUuNiA1LjYgNS42IDEuNC0xLjQtNS42LTUuNkwxOSA2LjR6IiBmaWxsPSIjMDAwIi8+PC9zdmc+);
	background-position: center center;
	background-repeat: no-repeat;
	background-color: transparent;
	outline: none;
	border: none;
	cursor: pointer;

	&:focus {
		box-shadow: inset 0 0 0 globalVariables.$global-radius colours.$ontario-colour-focus;
	}

	@media screen and (max-width: breakpoints.$small-breakpoint) {
		right: $ontario-search-button-width--mobile + spacing.$spacing-7;
	}
}

.ontario-search__submit {
	border: 0;
	border-radius: 0 3px 3px 0;
	background-color: colours.$ontario-colour-link;
	color: colours.$ontario-colour-black;

	display: flex;
	justify-content: center;
	align-items: center;

	font-family: fonts.$ontario-font-open-sans;
	font-weight: fontWeights.$ontario-font-weights-semi-bold;
	font-size: 1.125rem;
	width: $ontario-search-button-width;
	line-height: lineheight.$ontario-line-height-8;

	position: absolute;
	right: spacing.$spacing-0;
	bottom: spacing.$spacing-0;
	top: spacing.$spacing-0;
	cursor: pointer;

	&:hover {
		background-color: colours.$ontario-colour-link--hover;
		color: colours.$ontario-colour-white;
	}

	&:focus {
		outline: none;
		box-shadow: 0 0 0 globalVariables.$global-radius colours.$ontario-colour-focus;
		background-color: colours.$ontario-colour-link--hover;
		color: colours.$ontario-colour-white;
	}

	&:active {
		background-color: colours.$ontario-colour-link--active;
		color: colours.$ontario-colour-white;
	}

	svg {
		fill: colours.$ontario-colour-white;
		margin-right: spacing.$spacing-0;
		margin-bottom: spacing.$spacing-0;
		width: $ontario-search-icon-size;
		height: $ontario-search-icon-size;
		display: inline-block;
		vertical-align: middle;
		overflow: hidden;
	}

	@media screen and (max-width: breakpoints.$small-breakpoint) {
		width: $ontario-search-button-width--mobile;
	}
}

.ontario-search-autocomplete__suggestion-list {
	background-color: colours.$ontario-colour-white;
	border-radius: 0 0 globalVariables.$global-radius globalVariables.$global-radius;
	border-top: globalFunctions.px-to-rem(2) solid $ontario-search-autosuggest-box-shadow;
	box-shadow: 0 globalFunctions.px-to-rem(3) globalFunctions.px-to-rem(8) globalFunctions.px-to-rem(1)
		$ontario-search-autosuggest-box-shadow;
	clip-path: inset(0 globalFunctions.px-to-rem(-8) globalFunctions.px-to-rem(-8) globalFunctions.px-to-rem(-8));
	display: none;
	list-style: none;
	margin: globalFunctions.px-to-rem(-2) spacing.$spacing-0 spacing.$spacing-0 spacing.$spacing-0;
	padding: spacing.$spacing-0;
	overflow: hidden;
	position: absolute;
	width: 100%;
	z-index: zIndex.$ontario-z-index-above-medium;
}

.ontario-search-autocomplete__suggestion-list--open {
	display: block;
}

.ontario-search-autocomplete__suggestion-option {
	list-style: none;
	padding: spacing.$spacing-2 spacing.$spacing-4;
	background-color: colours.$ontario-colour-white;
	cursor: pointer;
	box-sizing: border-box;
	line-height: lineheight.$ontario-line-height-8;

	&:hover {
		background-color: colours.$ontario-colour-button-tertiary--hover;
	}

	&:focus {
		outline: none;
	}
}

.ontario-search-autocomplete__suggestion-option:last-child {
	padding-bottom: spacing.$spacing-2;
}

.ontario-search-autocomplete__suggestion-option--active,
.ontario-search-autocomplete__suggestion-option--hovered {
	background-color: colours.$ontario-colour-button-tertiary--hover;
}

.ontario-search-autocomplete__suggestion-option--disabled {
	opacity: $ontario-search-autocomplete-disabled-opacity;
	cursor: default;
}

.ontario-search-autocomplete__suggestion-content {
	display: block;
	width: 100%;
}

.ontario-search-autocomplete__suggestion-label {
	font-weight: fontWeights.$ontario-font-weights-bold;
}

.ontario-search-autocomplete__suggestion-match {
	font-weight: fontWeights.$ontario-font-weights-normal;
}

.ontario-search-autocomplete__suggestion-completion {
	font-weight: fontWeights.$ontario-font-weights-bold;
}

::slotted(.ontario-search-autocomplete__slot-option--hovered),
::slotted([slot='suggestions']:hover) {
	background-color: colours.$ontario-colour-button-tertiary--hover;
}

::slotted(.ontario-search-autocomplete__slot-option) {
	display: block;
	list-style: none;
	padding: spacing.$spacing-2 spacing.$spacing-4;
	margin: spacing.$spacing-0;
	line-height: lineheight.$ontario-line-height-8;
	background-color: colours.$ontario-colour-white;
	cursor: pointer;
	box-sizing: border-box;
	font-weight: fontWeights.$ontario-font-weights-bold;
}

// Required to keep hidden slotted options out of the rendered list regardless of consumer-provided slot styles.
::slotted([slot='suggestions'][hidden]),
::slotted(.ontario-search-autocomplete__slot-option[hidden]) {
	display: none !important;
}

::slotted(.ontario-search-autocomplete__slot-option--active),
::slotted(.ontario-search-autocomplete__slot-option--hovered) {
	background-color: colours.$ontario-colour-button-tertiary--hover;
}

::slotted(.ontario-search-autocomplete__slot-option[aria-disabled='true']) {
	opacity: $ontario-search-autocomplete-disabled-opacity;
	cursor: default;
}

$search-autocomplete-suggestion-description-line-height: 1.35;

.ontario-search-autocomplete__suggestion-description {
	line-height: $search-autocomplete-suggestion-description-line-height;
}

.ontario-search__visually-hidden {
	position: absolute;
	width: globalFunctions.px-to-rem(1);
	height: globalFunctions.px-to-rem(1);
	// Offset the element by 1px while keeping it available to assistive technologies.
	margin: globalFunctions.px-to-rem(-1);
	padding: spacing.$spacing-0;
	border: 0;
	clip: rect(0, 0, 0, 0);
	overflow: hidden;
}

// remove default cancel button for input with type="search"
input[type='search'].ontario-search__input::-webkit-search-decoration,
input[type='search'].ontario-search__input::-webkit-search-cancel-button,
input[type='search'].ontario-search__input::-webkit-search-results-button,
input[type='search'].ontario-search__input::-webkit-search-results-decoration {
	-webkit-appearance: none;
}
